import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { PrepaidPlan } from 'src/features/subscriptions/types';

const RESOURCE = '/parkings/:parkingId/prepaid-plan/:planId/';

interface DTO {
    parkingId: string;
    planId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, planId, ...data }: DTO): Promise<PrepaidPlan> => {
    return axios.delete(formatResourcePath(RESOURCE, { parkingId, planId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteSubscriptionPlan };
